import { useEffect, useRef } from "react";
import bwipjs from "bwip-js";

export default function Barcode({ value, scale = 3, height = 18, className = "", showText = true }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      bwipjs.toCanvas(ref.current, {
        bcid: "pdf417",
        text: value,
        scale,
        height,
        columns: 6,
        includetext: false,
        backgroundcolor: "FFFFFF",
        paddingwidth: 8,
        paddingheight: 8,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Barcode render failed", e);
    }
  }, [value, scale, height]);

  return (
    <div className={`bg-white rounded-lg p-3 flex flex-col items-center ${className}`}>
      <canvas ref={ref} data-testid="pdf417-canvas" />
      {showText && (
        <div className="mt-2 text-slate-900 text-xs font-mono-fb tracking-wider break-all text-center">
          {value}
        </div>
      )}
    </div>
  );
}
